import { useNavigate } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Topic } from "../../core/topic/entities/Topic";
import { DataTable } from "../components/table/DataTable";
import topicTableConfig from "./config/topic/topicTableConfig";
import { useTrainingRoute } from "../../core/hooks/useTrainingRoute";
import { useAdminPermissions } from "../../core/hooks/useAdminPermissions";
import { useCallback } from "react";
import { getAllTopicsUseCase } from "../../core/topic/useCases/getAllTopicsUseCase";
import { updateTopicOrderUseCase } from "../../core/topic/useCases/updateTopicOrderUseCase";

export default function TrainingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { trainingId, topicPath } = useTrainingRoute();
  const permissions = useAdminPermissions();

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["topics", trainingId],
    queryFn: async () => {
      return await getAllTopicsUseCase.exec(trainingId!);
    },
    enabled: !!trainingId, // N'effectue la requête que si trainingId est défini
  });

  const handleReorder = useCallback(
    async (list: Topic[]) => {
      const success = await updateTopicOrderUseCase.exec(list);
      if (success) refetch();
    },
    [refetch]
  );

  return (
    <PageLayout isLoading={isLoading}>
      {trainingId && (
        <DataTable
          key={"table"}
          title={t("topic.title")}
          datas={data || []}
          columns={topicTableConfig(t, topicPath)}
          filters={["title", "description"]}
          onRowClicked={(row: Topic) => navigate(topicPath(row.id))}
          onAdd={
            permissions.canCreate ? () => navigate(topicPath("new")) : undefined
          }
          onReorder={permissions.canReorder ? handleReorder : undefined}
        />
      )}
    </PageLayout>
  );
}
